import { useTheme, Box, Chip } from "@mui/material";
import {
  VisibilityOffRounded,
  VisibilityRounded,
  LoopRounded,
  LockRounded,
  PsychologyRounded,
  ShuffleRounded,
  TextFieldsRounded,
  CallMissedOutgoingRounded,
} from "@mui/icons-material";

const InfoChips = ({ conversion, isViewPage = false, size = "medium" }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      {conversion?.isAutoCode && (
        <Chip
          icon={<ShuffleRounded color="white" />}
          label="autocode"
          size={size}
          sx={{
            backgroundColor:
              theme.palette.mode === "light" ? "#451952" : "#662549",
            color: "white",
          }}
        />
      )}
      {conversion?.isSmartCode && (
        <Chip
          icon={<PsychologyRounded color="white" />}
          label="smartcode"
          size={size}
          color="secondary"
          sx={{ color: "white" }}
        />
      )}
      {conversion?.isCustomCode && (
        <Chip
          icon={<TextFieldsRounded color="white" />}
          label="customcode"
          size={size}
          color="warning"
          sx={{ color: "white" }}
        />
      )}
      {conversion?.revealable ? (
        <Chip
          icon={<VisibilityRounded color="white" />}
          label="revealable"
          size={size}
          color="info"
          sx={{ color: "white" }}
        />
      ) : (
        <Chip
          icon={<VisibilityOffRounded color="white" />}
          label="hidden"
          size={size}
          sx={{
            backgroundColor:
              theme.palette.mode === "light" ? "#144272" : "#2C74B3",
            color: "white",
          }}
        />
      )}
      {!!conversion?.passcodeLength && (
        <Chip
          icon={<LockRounded color="white" />}
          label="locked"
          size={size}
          sx={{
            backgroundColor:
              theme.palette.mode === "light" ? "#36846B" : "#4BB39A",
            color: "white",
          }}
        />
      )}
      {conversion?.isDead && (
        <Chip
          icon={<LoopRounded color="white" />}
          label="dead"
          size={size}
          sx={{
            backgroundColor:
              theme.palette.mode === "light" ? "#7D0A0A" : "#BF3131",
            color: "white",
          }}
        />
      )}
      {!isViewPage &&
        !!conversion?.redirects?.length &&
        conversion.redirects.length > 0 && (
          <Chip
            icon={<CallMissedOutgoingRounded color="white" />}
            label={`redirects: ${conversion.redirects.length}`}
            size={size}
            sx={{
              backgroundColor:
                theme.palette.mode === "light" ? "#8D0B41" : "#a12a42",
              color: "white",
            }}
          />
        )}
    </Box>
  );
};

export default InfoChips;
